
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            type: '',
            status: '',
            created_at: [],
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };


        // 查看
        detailDialog = false
        detailInfo = {}
        toDetail(id: any) {
            api.post('A10002', {id}).then(res => {
                this.detailInfo = res
                this.detailDialog = true
            })
        }
        //日志
        logDialog = false
        logTable = []
        logTotal = 0
        logSearch = {
            id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        toLog(id: any) {
            this.logSearch.id = id
            api.post('A10003', this.logSearch).then(res => {
                this.logTable = res.list
                this.logTotal = res.logTotal
                this.logDialog = true
            })
        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A10001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
        }
    }
